import classNames from 'classnames';
import { Box } from '@mui/material';
import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import AppAvatar from 'components/shared/AppAvatar/AppAvatar';
import { AdminAccess } from 'enum/UserRole';
import { formatServiceRole } from 'utils/formatServiceRole';
import { useTypedDispatch } from 'hooks/useTypedDispatch';
import { setAccount, setService } from 'store/auth/authReducer';

import './ListMenuItem.scss';

interface IListItem {
  name: string,
  accountShortName?: string,
  accountName?: string,
  logo?: string | null,
  shortName: string,
  access?: AdminAccess | null,
  onClick: () => void,
  className?: string,
}

const ListMenuItem: FC<IListItem> = ({
  name,
  logo,
  shortName,
  access,
  onClick,
  accountName,
  accountShortName,
  className,
}) => {
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  const handleClick = useCallback(() => {
    dispatch(setService(null));
    dispatch(setAccount(null));
    navigate(`${accountShortName}/${shortName}`);
    onClick();
  }, [shortName, accountShortName]);

  return (
    <Box className={classNames('list-item', className)} onClick={handleClick}>
      <AppAvatar path={logo ?? ''} />
      <Box className="main">
        <Box className="text">
          <Box className="name">{name}</Box>
          <Box className="account">{accountName}</Box>
          <Box className="role">{formatServiceRole(access)}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ListMenuItem;
